import { DateTimeHelper } from "src/app/core/helper/datetime.helper";
import { DateTime } from 'luxon';

export class StripeBalance{
    available: StripeBalanceAmount[];
    connect_reserved: StripeBalanceAmount[];
    pending: StripeBalanceAmount[];

    get availableAmount(){
        let amt:number = 0;
        if(this.available && this.available.length > 0){
            this.available.forEach(k=> {
                amt += k.amount;
            });
        }
      
        return amt / 100;
    }
    get pendingAmount(){
        let amt:number = 0;
        if(this.pending && this.pending.length > 0){
            this.pending.forEach(k=> {
                amt += k.amount;
            });
        }
        return amt / 100;
    }

    public constructor(init?: Partial<StripeBalance>) {
        Object.assign(this, init);
    }
}

export class StripeBalanceAmount {
    amount: number;
    currency: string;

    public constructor(init?: Partial<StripeBalanceAmount>) {
        Object.assign(this, init);
    }
}

export class StripePayoutRequest {
    accountId: string;
    bankAccountId: string;
    amount: number;
    currency: string;
}

export class StripePayout {
    statement_descriptor: string;
    source_type: string;
    method: string;
    metadata: { [key: string]: string; };
    livemode: boolean;
    failure_message: string;
    failure_code: string;
    description: string;
    currency: string;
    created: Date;
    automatic: boolean;
    arrival_date: Date;
    amount: number;
    object: string;
    id: string;
    status: string;
    type: string;

    createdDisplay: string;

    get payoutAmount() { return this.amount / 100; }

    public constructor(init?: Partial<StripePayout>) {
        Object.assign(this, init);

        // this date comes from stripe, so we need this ugly beast
        const d = DateTime.fromISO(new Date(this.created).toISOString()).toISO();
        this.createdDisplay = DateTimeHelper.formatDate(d);
    }
}